import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines multiple class names and resolves Tailwind CSS conflicts
 * This is a core utility used by shadcn/ui components
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
} 